/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
// import { batchActions } from "redux-batched-actions";
// actions
import { setEditMode, updatePageDetails, changePage } from 'state/actions/app_status';
import { editReport } from 'state/actions/reportsState/reports_status';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import PreviewPage from 'pages/dashboard/reports/preview/preview';



/* ========== ~~~~~~~~~~ PAGE : REPORTS : PREVIEW : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ appStatus, reportsState }) => ({
    isDataReceived: reportsState.reportsStatus.isDataReceived,
    clientReports: reportsState.reportsStatus.clientEmbeds,
    previewData: reportsState.selectedReportStatus.previewReportData,
    accountUUID: reportsState.selectedReportStatus.selectedReportData.accountUUID,
    dateRange: reportsState.selectedReportStatus.selectedReportData.dateRange,
    isReportSaved: reportsState.selectedReportStatus.status.isReportSaved,
    customDateRange: reportsState.selectedReportStatus.selectedReportData.customDateRange,
    processing: reportsState.selectedReportStatus.status.processing,
    currentPage: appStatus.currentPage
});

// map actions
const mapDispatchToProps = dispatch => ({
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
    setEditMode: editState => dispatch(setEditMode(editState)),
    editReport: reportUUID => dispatch(editReport(reportUUID))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PreviewPage);